/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM, convertHexToRGB } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : REPORT METRICS : STYLES --------------- ++++++++++ */
export default theme => ({
	metrics: {
		'& .metrics-options': {
			margin: replacePXinStringWithEM('15px 10px'),
			'& .list-item .option-text': {
				opacity: 1
			}
		},
		'& .errormessage': {
			opacity: '0',
			display: 'block',
			color: convertHexToRGB(theme.color.attention.dark.swatch, 50),
			fontSize: pxToEm(14),
			marginTop: pxToEm(5),
			// animate in 
			animationName: 'fadeInDown',
			animationDelay: '0s',
			animationDuration: '.1s',
			animationFillMode: 'forwards',
		}
	}
});
